module.exports = "pegasus/assets/blocks/column-lp11-themelp1.png";